module.exports = __webpack_public_path__ + "img/just_logo.21e1b9c5.png";